import React, { useContext, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { alertErrorMessage, alertSuccessMessage } from "../../../Services/CustomAlertModel";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import AuthService from "../../../Services/ApiServices/AuthService";
import Sidebar from "../../CoustamComponent/Sidebar";
import { ProfileContext } from "../../../Services/ProfileProvider";

const ManualUserKyc = () => {

	const { userDetails,handleUserProfile } = useContext(ProfileContext);
	const userId = userDetails?._id;
	const KycStatus = userDetails?.kycVerified;
	const navigate = useNavigate();

	const [formData, setFormData] = useState({
		documentType: "Aadhar Card",
		documentFront: null,
		documentBack: null,
		documentNumber: "",
	});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleFileChange = async (e) => {
		const { name, files } = e.target;
		setFormData({ ...formData, [name]: files[0] });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			var formValue = new FormData();
			formValue.append("document_type", formData.documentType);
			formValue.append("user_aadhar_front_image", formData.documentFront);
			formValue.append("user_aadhar_back_image", formData.documentBack);
			formValue.append("document_number", formData.documentNumber);
			formValue.append("user_id", userId);
			LoaderHelper.loaderStatus(true);
			const result = await AuthService.submitKycManual(formValue);
			if (result?.success) {
				alertSuccessMessage(result?.message);
				handleUserProfile();
				navigate("/");
			} else {
				alertErrorMessage(result);
			}
		} catch (error) {
			alertErrorMessage(error?.message || 'An error occurred during submission');
		} finally {
			LoaderHelper.loaderStatus(false);
		}
	};

	return (
		<div class="wrapper dashboard_page ">
			<div class=" page-body d-flex align-items-stretch">
				<div class="page-content">
					<Sidebar />
					<div className="page_wrapper" >
						<div className="container container-custom" >
							<div className="row g-3" >
								<div className="col-lg-12" >
									<div className="card bal_card_main" >
										{
											KycStatus === 0 || KycStatus === 3 ?
												<div class="card-body ">
													<h4>Document Verification</h4>
													<form onSubmit={handleSubmit} className="mt-4 mt-xl-5">
														<div class="mb-3">
															<label className="form-label">Select Document</label>
															<select
																className="form-control form-select"
																name="documentType"
																value={formData.documentType}
																onChange={handleInputChange}
																required
															>
																<option>Aadhar Card</option>
																<option>Passport</option>
															</select>
														</div>
														<div class="mb-3">
															<label className="form-label">Document Number</label>
															<input
																className="form-control"
																type="text"
																name="documentNumber"
																value={formData.documentNumber}
																onChange={handleInputChange}
																required
																maxLength={formData.documentType === "Aadhar Card" ? 12 : 20}
															/>
														</div>
														<div class="mb-3">
															<label className="form-label">Document Image (Front)</label>
															<input
																className="form-control"
																type="file"
																name="documentFront"
																onChange={handleFileChange}
																required
															/>
														</div>
														<div class="mb-3">
															<label className="form-label">Document Image (Back)</label>
															<input
																className="form-control"
																type="file"
																name="documentBack"
																onChange={handleFileChange}
																required
															/>
														</div>
														<div className="form-group">
															<button
																className="btn btn-primary w-100 btn-block"
																type="submit"
															>
																Submit
															</button>
														</div>
													</form>
												</div>
												:
												<div className="card-body" >
													<h5 className={`text-center ${KycStatus === 1 ? "text-warning" : "text-success"}`}>
														{KycStatus === 1 ? "Document UnderReview" : "Document Verified"}
													</h5>
													<img src="/assets/images/verified_documents.svg" className="img-fluid" />
												</div>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ManualUserKyc;
